module.exports = __webpack_public_path__ + "static/media/trimble.9b4cb32f.png";